import React from "react";
import { bannerImg } from "../../assets/index";
import KSLogo from "../logo/KSLogo";

/**
 * RightBanner
 * Cyber-styled hero portrait with:
 *  - Rotating dashed orbit rings behind the photo
 *  - Faint glowing KS monogram floating in the background
 *  - Animated keyword annotations (SECURE APIS / API TESTING / OWASP / DEVSECOPS)
 *    each anchored by a pulsing accent dot + connector line
 */
const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 relative flex justify-center items-end min-h-[560px] lgl:min-h-[680px]">
      {/* === Background layer ================================================= */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
        {/* Rotating orbit rings */}
        <div className="relative w-[420px] h-[420px] lgl:w-[560px] lgl:h-[560px]">
          <div className="cyber-orbit cyber-orbit--slow w-full h-full" />
          <div className="cyber-orbit cyber-orbit--fast w-[78%] h-[78%]" />
          <div className="cyber-orbit w-[55%] h-[55%] border-white/10" />
          {/* Faint KS shadow logo */}
          <div className="cyber-ks-shadow">
            <KSLogo size={320} glow />
          </div>
        </div>
      </div>

      {/* === Cyber keyword annotations ====================================== */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="cyber-keyword kw-secure">
          SECURE
          <span className="kw-accent"> APIS</span>
          <span className="kw-line w-20" />
        </div>
        <div className="cyber-keyword kw-api">
          API
          <span className="kw-accent"> TESTING</span>
          <span className="kw-line w-20 ml-auto" />
        </div>
        <div className="cyber-keyword kw-owasp">
          OWASP
          <span className="kw-accent"> TOP 10</span>
          <span className="kw-line w-20" />
        </div>
        <div className="cyber-keyword kw-devsec">
          DEVSECOPS
          <span className="kw-accent"> READY</span>
          <span className="kw-line w-20 ml-auto" />
        </div>
      </div>

      {/* === Portrait + soft pedestal glow =================================== */}
      <img
        className="relative z-10 w-[300px] h-[400px] lgl:w-[500px] lgl:h-[680px] object-contain drop-shadow-[0_0_35px_rgba(255,1,79,0.18)]"
        src={bannerImg}
        alt="Kushal Sharma portrait"
      />
      <div className="absolute bottom-0 z-0 w-[280px] h-[260px] lgl:w-[460px] lgl:h-[420px] bg-gradient-to-t from-[#1a1c1f] via-[#1e2024]/70 to-transparent shadow-shadowOne" />
    </div>
  );
};

export default RightBanner;
